/** Detalhe/edição/exclusão de um post. Onda 16 (fecha o editar/excluir da Onda 14). */
import { useEffect, useState } from "react";
import type { FormEvent } from "react";
import { Link, useNavigate, useParams } from "react-router";
import type { PostDTO } from "@unik/shared";
import { localInputToUtcIso, utcIsoToLocalInputs, statusLabel } from "@unik/shared";
import { api, ApiClientError } from "../../lib/api";
import { AdminShell } from "../../ui/AdminShell";
import { Button } from "../../ui/Button";
import { Input, CaptionField } from "../../ui/Input";
import { Select } from "../../ui/Select";

export function PostDetalhe() {
  const { id, postId } = useParams();
  const navigate = useNavigate();

  const [post, setPost] = useState<PostDTO | null>(null);
  const [caption, setCaption] = useState("");
  const [purpose, setPurpose] = useState("aquecer");
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api
      .get<PostDTO>(`/posts/${postId}`)
      .then((p) => {
        setPost(p);
        setCaption(p.caption);
        setPurpose(p.purpose);
        if (p.scheduledAt !== null) {
          const parts = utcIsoToLocalInputs(p.scheduledAt);
          setDate(parts.date);
          setTime(parts.time);
        }
      })
      .catch(() => setError("Post não encontrado."));
  }, [postId]);

  async function salvar(e: FormEvent) {
    e.preventDefault();
    setSaving(true);
    setError(null);
    const scheduledAt = date !== "" && time !== "" ? localInputToUtcIso(date, time) : null;
    try {
      await api.patch(`/posts/${postId}`, { caption, purpose, scheduledAt });
      navigate(`/clientes/${id}/esteira`);
    } catch (err) {
      setError(err instanceof ApiClientError ? err.message : "Não foi possível salvar.");
    } finally {
      setSaving(false);
    }
  }

  async function excluir() {
    if (!window.confirm("Excluir este post? Esta ação não pode ser desfeita.")) return;
    setDeleting(true);
    try {
      await api.del(`/posts/${postId}`);
      navigate(`/clientes/${id}/esteira`);
    } catch {
      setError("Não foi possível excluir o post. Tente novamente.");
      setDeleting(false);
    }
  }

  if (error !== null)
    return <AdminShell><p className="type-body text-danger">{error}</p></AdminShell>;
  if (post === null)
    return <AdminShell><p className="type-body text-text-secondary">Carregando…</p></AdminShell>;

  return (
    <AdminShell>
      <Link to={`/clientes/${id}/esteira`} className="type-caption text-text-tertiary">
        ← Voltar à esteira
      </Link>
      <div className="mt-1 flex items-center gap-3">
        <h1 className="type-h1 text-text-cream">Post</h1>
        <span className="type-caption text-text-tertiary">{statusLabel(post.status, "admin")}</span>
      </div>

      <div className="mt-4 flex gap-2 overflow-x-auto">
        {post.media.map((m) => (
          <img
            key={m.id}
            src={m.publicUrl}
            alt=""
            className="h-44 shrink-0 rounded-[var(--radius-control)] object-cover"
          />
        ))}
      </div>

      <form onSubmit={salvar} className="mt-5 flex flex-col gap-5" noValidate>
        <CaptionField label="Legenda" value={caption} onChange={(e) => setCaption(e.target.value)} />
        <Select label="Função" value={purpose} onChange={(e) => setPurpose(e.target.value)}>
          <option value="aquecer">Aquecer</option>
          <option value="qualificar">Qualificar</option>
          <option value="vender">Vender</option>
        </Select>
        <div className="grid grid-cols-2 gap-3">
          <Input label="Data" type="date" value={date} onChange={(e) => setDate(e.target.value)} />
          <Input label="Horário" type="time" value={time} onChange={(e) => setTime(e.target.value)} />
        </div>
        {error !== null && <p className="type-caption text-danger" role="alert">{error}</p>}
        <div className="flex gap-3">
          <Button type="submit" loading={saving}>Salvar</Button>
          <Button type="button" variant="danger" onClick={excluir} loading={deleting}>Excluir</Button>
        </div>
      </form>
    </AdminShell>
  );
}
